import React, { useEffect, useState } from "react";
import { PopupNoticeContainer } from "../../style/StyleComponentUtility";
import { get_popup_notice } from "../../Axios";
import arrow from "../../assets/icons/arrow_back_ios_white_20.svg";
import { useNavigate } from "react-router-dom";

interface NoticeObject {
  ablack_notice_ID : number;
  ablack_notice_title : string;
  ablack_notice_content : string | TrustedHTML;
  ablack_notice_top_status : number;
  ablack_notice_popup : number;
  ablack_notice_registe : any;
  ablack_notice_modified : any;
  ablack_notice_current_time : any;
  connection_query : string;
};

interface Props {
  closePopup: () => void;
  handleNoPopupToday: () => void;
};

const PopupNotice: React.FC<Props> = ({closePopup, handleNoPopupToday}) => {
  const navigate = useNavigate();
  const [popupNoticeList, setPopupNoticeList] = useState<NoticeObject[]>([]);
  const [totalPopupNotice, setTotalPopupNotice] = useState<number>(0);
  const [currentPopupNotice, setCurrentPopupNotice] = useState<NoticeObject>();
  const [popupIndex, setPopupIndex] = useState<number>(0);

  useEffect(() => {
    get_popup_notice().then(result => {
      setPopupNoticeList(result.rows);
      setTotalPopupNotice(result.total_count);
    });
  }, [closePopup]);

  useEffect(() => {
    if (popupNoticeList.length >= 1) {
      let obj = popupNoticeList[popupIndex];
      setCurrentPopupNotice(obj);
    }
  }, [popupIndex, popupNoticeList]);

  return (
    <>
    {totalPopupNotice > 0 &&
      <PopupNoticeContainer>
        <div className="popup-wrapper">
          <div className="notice-title-box">
            {currentPopupNotice?.ablack_notice_title}
          </div>
          {currentPopupNotice ?
            <div
              className="content-box"
              dangerouslySetInnerHTML={{__html : currentPopupNotice?.ablack_notice_content}}
            />
            :
            <div
              className=""
            />
          }
          <div className="show-detail-box">
            <button
              onClick={() => {
                navigate('/notice_select_one', { state : {ablack_notice_ID : currentPopupNotice?.ablack_notice_ID}})
              }}
            >
              자세히 보기
            </button>
          </div>
        </div>
        <div className="popup-layout">
          <div className="popup-footer">
            <button
              className="daily-close"
              onClick={() => handleNoPopupToday()}
            >
              오늘하루 그만보기
            </button>
            <button
              className="close"
              onClick={() => closePopup()}
            >
              닫기
            </button>
          </div>
        </div>
        {totalPopupNotice >= 2 &&
          <>
            <button className="navigation prev" 
              onClick={() => {
                if (popupIndex === 0) {
                  setPopupIndex(totalPopupNotice-1);
                } else {
                  setPopupIndex(prev => prev -1);
                }
              }}
            >
              <img src={arrow} alt="" width={25} height={25} />
            </button>
            <button className="navigation next"
              onClick={() => {
                if (popupIndex < totalPopupNotice - 1) {
                  setPopupIndex(prev => prev +1);
                } else if (popupIndex === totalPopupNotice -1) {
                  setPopupIndex(0);
                }
              }}
            >
              <img src={arrow} alt="" width={25} height={25} />
            </button>
            <div className="index-display">
              <div className="wrapper">
                <span>{popupIndex+1}</span>
                <span>&nbsp;/&nbsp;</span>
                <span>{totalPopupNotice}</span>
              </div>
            </div>
          </>
        }
      </PopupNoticeContainer>
    }
    </>
  )
};

export default PopupNotice;
